export default {"src":"/_next/static/media/redux.888cf526.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};